import type { DashboardSummary, ManagedChannelType } from '@shared/types/domain';
import { pathIsVisible } from './channelVisibility';
export function visibleDashboard(
  data: DashboardSummary | undefined,
  types: ManagedChannelType[],
): DashboardSummary | undefined {
  if (!data) return data;
  const enabled = (code: string) => types.some((x) => x.code === code && x.enabled);
  const sourceVisible = (source: string) => {
    const code =
      (
        {
          livechat: 'live_chat',
          'Live Chat': 'live_chat',
          WhatsApp: 'whatsapp',
          Tickets: 'tickets',
          calls: 'call_logs',
          Calls: 'call_logs',
        } as Record<string, string>
      )[source] ?? source;
    return !['tickets', 'whatsapp', 'live_chat', 'call_logs'].includes(code) || enabled(code);
  };
  return {
    ...data,
    kpis: data.kpis.filter(
      (kpi) =>
        (kpi.id !== 'waiting' || enabled('whatsapp') || enabled('live_chat')) &&
        (!['open', 'pending', 'breach', 'response', 'resolved'].includes(kpi.id) ||
          enabled('tickets')),
    ),
    attention: data.attention.filter((x) => pathIsVisible(x.route, types)),
    channelVolume: data.channelVolume.filter((x) => sourceVisible(x.channel)),
    statusVolume: enabled('tickets') ? data.statusVolume : [],
    ...(data.sources ? { sources: data.sources.filter((x) => sourceVisible(x.source)) } : {}),
    ...(data.queues ? { queues: data.queues.filter((x) => sourceVisible(x.channel)) } : {}),
    ...(data.activity
      ? {
          activity: data.activity.map((x) => ({
            ...x,
            ticketsCreated: enabled('tickets') ? x.ticketsCreated : null,
            ticketsResolved: enabled('tickets') ? x.ticketsResolved : null,
            whatsAppSessions: enabled('whatsapp') ? x.whatsAppSessions : null,
          })),
        }
      : {}),
    workload: data.workload.map((x) => ({
      ...x,
      tickets: enabled('tickets') ? x.tickets : null,
      chats: enabled('whatsapp') ? x.chats : null,
      capacity: enabled('whatsapp') ? (x.capacity ?? null) : null,
      occupancy: enabled('whatsapp') ? x.occupancy : null,
    })),
    ...(data.navigationCounts
      ? {
          navigationCounts: Object.fromEntries(
            Object.entries(data.navigationCounts).filter(([path]) => pathIsVisible(path, types)),
          ),
        }
      : {}),
  };
}
